module.exports = __webpack_public_path__ + "static/img/main.621728d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/main.png
// module id = +vK+
// module chunks = 1